import { DetailsChildrenTab, type DetailsPageProps } from 'app/main/components/page-layouts';

import ActivitiesListItem from 'app/main/modules/activities/ActivitiesListItem';
import ChronologyListItem from 'app/main/modules/chronology/ChronologyListItem';
import ContractsListItem from 'app/main/modules/contracts/ContractsListItem';
import OrdersListItem from 'app/main/modules/orders/OrdersListItem';
import ProjectsListItem from 'app/main/modules/projects/ProjectsListItem';
import WorkReportsListItem from 'app/main/modules/workreports/WorkReportsListItem';

import WbsTab from 'app/main/submodules/wbs/WbsTab';
import OpportunitiesDetailsTab from './tabs/OpportunitiesDetailsTab';

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <OpportunitiesDetailsTab {...props} />
	},
	{
		id: 'contracts',
		title: 'MODULE_CONTRACTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('contracts') || authorizer.cannot('view', 'contracts'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="contracts"
				content={{ type: 'list', itemLayout: ContractsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'cntr_oppo_uid', filt_clause: 'equals', filt_value: model.oppo_uid }]}
			/>
		)
	},
	{
		id: 'orders',
		title: 'MODULE_ORDERS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('orders') || authorizer.cannot('view', 'orders'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="orders"
				content={{ type: 'list', itemLayout: OrdersListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'ords_oppo_uid', filt_clause: 'equals', filt_value: model.oppo_uid }]}
			/>
		)
	},
	{
		id: 'projects',
		title: 'MODULE_PROJECTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('projects') || authorizer.cannot('view', 'projects'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="projects"
				content={{ type: 'list', itemLayout: ProjectsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'proj_oppo_uid', filt_clause: 'equals', filt_value: model.oppo_uid }]}
			/>
		)
	},
	// {
	// 	id: 'wbs',
	// 	title: 'TAB_WBS',
	// 	disabled: ({ isEdit }) => isEdit,
	// 	hidden: ({ isModuleDisabled, authorizer }) => isModuleDisabled('wbs') || authorizer.cannot('view', 'wbs'),
	// 	content: ({ model, updateRefresh }) => (
	// 		<WbsTab
	// 			root={{
	// 				table: 'opportunities',
	// 				tableId: model.oppo_uid,
	// 				title: model.oppo_title,
	// 				dateFrom: model.oppo_d_from,
	// 				dateTo: model.oppo_d_to,
	// 				hasWbs: model.oppo_wbs,
	// 				isEditable: model.oppo_wbs_editable
	// 			}}
	// 			updateRefresh={updateRefresh}
	// 		/>
	// 	)
	// },
	{
		id: 'activities',
		title: 'MODULE_ACTIVITIES_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('activities') || authorizer.cannot('view', 'activities'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="activities"
				content={{ type: 'list', itemLayout: ActivitiesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'acti_oppo_uid', filt_clause: 'equals', filt_value: model.oppo_uid }]}
			/>
		)
	},
	{
		id: 'chronology',
		title: 'MODULE_CHRONOLOGY_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('chronology') || authorizer.cannot('view', 'chronology'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="chronology"
				content={{ type: 'list', itemLayout: ChronologyListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'chro_oppo_uid', filt_clause: 'equals', filt_value: model.oppo_uid }]}
			/>
		)
	},
	{
		id: 'workreports',
		title: 'MODULE_WORKREPORTS_NAME',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('workreports') || authorizer.cannot('view', 'workreports'),
		content: ({ model, updateRefresh, refresh }) => (
			<DetailsChildrenTab
				module="workreports"
				content={{ type: 'list', itemLayout: WorkReportsListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'wore_oppo_uid', filt_clause: 'equals', filt_value: model.oppo_uid }]}
			/>
		)
	}
];

export default tabs;
